import styled from '@emotion/styled'

import { IconButtonHoverActions } from './elements/IconButtons/styles'

export const NavListItemWithIconButtonsWrapper = styled.div`
  &:hover {
    ${() => IconButtonHoverActions} {
      opacity: 1;
      pointer-events: all;
    }
  }
`
